import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";
import { ACTION_GET_CURRENT_COMPANY_INFO } from "../GetCurrentCompanyInfo/useGetCurrentCompanyInfo";

import { companiesApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_DELETE_COMPANY_LOGO = "DELETE_COMPANY_LOGO";

const allowedRoles = [UserRole.Owner];

interface DeleteCompanyLogoProps {
  companyId: string;
}

const deleteCompanyLogo = async (params: DeleteCompanyLogoProps): Promise<void> => {
  const { companyId } = params;

  await companiesApi.companiesControllerDeleteCompanyLogo(companyId);
};

export const useDeleteCompanyLogo = (
  user: UserProfileDto | null,
): {
  deleteCompanyLogo: (params: DeleteCompanyLogoProps) => void;
  deleteCompanyLogoEnabled: boolean;
  isSuccessDeleteCompanyLogo: boolean;
  isPendingDeleteCompanyLogo: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation<
    void,
    Error,
    DeleteCompanyLogoProps
  >({
    mutationKey: [DOMAIN_COMPANIES, ACTION_DELETE_COMPANY_LOGO],
    mutationFn: enabled ? deleteCompanyLogo : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_COMPANIES, ACTION_GET_CURRENT_COMPANY_INFO],
      });
    },
  });

  return {
    deleteCompanyLogo: mutate,
    deleteCompanyLogoEnabled: enabled,
    isSuccessDeleteCompanyLogo: isSuccess,
    isPendingDeleteCompanyLogo: isPending,
  };
};
